import { Subscription, tap } from 'rxjs';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UploaderValue } from '../subtitles-uploader/models';
import { SubtitlesControlsModel } from '../../../../models';
import { FileDownloadService } from '@app/core/service/file-download/file-download.service';

@Component({
    selector: 'app-upload-subtitles-item',
    templateUrl: './subtitles-item.component.html',
    styleUrls: ['./subtitles-item.component.scss'],
    providers: [FileDownloadService],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class UploadSubtitlesItemComponent implements OnInit, OnDestroy {
    private cdr = inject(ChangeDetectorRef);
    private fileDownloadService = inject(FileDownloadService);

    @Input({ required: true }) subtitlesControls!: FormGroup<SubtitlesControlsModel>;
    @Input({ required: true }) index!: number;
    @Output() removeSubtitles = new EventEmitter<number>();

    private readonly subsriptions$ = new Subscription();

    fileControl = new FormControl<UploaderValue>({
        file: null,
        hash: null,
    });

    ngOnInit(): void {
        this.subsriptions$.add(
            this.fileControl.valueChanges
                .pipe(
                    tap(() => {
                        this.subtitlesControls.controls.filename?.patchValue(this.fileName);
                        this.subtitlesControls.controls.hash?.patchValue(this.hash ?? null);
                        this.cdr.detectChanges();
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subsriptions$.unsubscribe();
    }

    get newLanguageControl() {
        return this.subtitlesControls.controls.newLanguage;
    }

    get subtitlesStatusControl() {
        return this.subtitlesControls.controls.status;
    }

    get hasHash() {
        return (this.fileControl.value?.hash?.length ?? 0) > 0;
    }

    get hasFile() {
        return this.fileControl.value?.file;
    }

    get downloadSubtitlesUrl() {
        const url = this.subtitlesControls.get('downloadUrl')?.value;
        return url && url + `?response-content-disposition=attachment; filename="${this.fileName}"`;
    }

    get hash() {
        return this.fileControl.value?.hash;
    }

    get fileName() {
        const name = this.hasFile ? this.fileControl.value?.file?.name : this.subtitlesControls.get('filename')?.value;
        return name && name.length > 0 ? name : null;
    }

    get subtitlesEnabledControl() {
        return this.subtitlesControls.controls.enabled;
    }

    remove() {
        this.removeSubtitles.next(this.index);
    }

    downloadSubtitles() {
        const url = this.downloadSubtitlesUrl;
        if (!url) {
            return;
        }
        const filename = ';filename=' + this.fileName;
        this.fileDownloadService.downloadSubtitles(url, filename);
    }
}
